module.exports = __webpack_public_path__ + "img/b716676382e219d6939103f2e547e766.e8a27abb.png";